import { useRef, useState } from "react";
import { Eraser } from "lucide-react";

// Lienzo para firmar con el dedo o el ratón. Devuelve un PNG transparente (data URL) o "" si se borra.
export const FirmaPad = ({ onChange, testid = "firma-pad" }) => {
  const ref = useRef(null);
  const dibujando = useRef(false);
  const [vacia, setVacia] = useState(true);

  const ctx = () => {
    const cv = ref.current;
    const ratio = window.devicePixelRatio || 1;
    if (cv.width !== Math.round(cv.offsetWidth * ratio)) {
      cv.width = Math.round(cv.offsetWidth * ratio);
      cv.height = Math.round(cv.offsetHeight * ratio);
    }
    const c = cv.getContext("2d");
    c.setTransform(ratio, 0, 0, ratio, 0, 0);
    Object.assign(c, { lineWidth: 2.4, lineCap: "round", lineJoin: "round", strokeStyle: "#1B2B4B" });
    return c;
  };
  const punto = (e) => {
    const cv = ref.current;
    const r = cv.getBoundingClientRect();
    return [(e.clientX - r.left) * (cv.offsetWidth / r.width), (e.clientY - r.top) * (cv.offsetHeight / r.height)];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture?.(e.pointerId);
    dibujando.current = true;
    const c = ctx();
    const [x, y] = punto(e);
    c.beginPath(); c.moveTo(x, y); c.lineTo(x + 0.1, y + 0.1); c.stroke();
  };
  const move = (e) => {
    if (!dibujando.current) return;
    const c = ref.current.getContext("2d");
    const [x, y] = punto(e);
    c.lineTo(x, y); c.stroke();
  };
  const up = () => {
    if (!dibujando.current) return;
    dibujando.current = false;
    setVacia(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const borrar = () => {
    const cv = ref.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    setVacia(true);
    onChange("");
  };

  return (
    <div>
      <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-white overflow-hidden">
        <canvas ref={ref} className="block w-full h-40 touch-none cursor-crosshair" data-testid={testid}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} />
        <div className="pointer-events-none absolute left-6 right-6 bottom-9 border-b border-slate-200" />
        {vacia && <p className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-slate-400">Firma aquí con el dedo o el ratón</p>}
      </div>
      <button type="button" onClick={borrar} className="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-700" data-testid={`${testid}-borrar`}>
        <Eraser className="w-3.5 h-3.5" /> Borrar y volver a firmar
      </button>
    </div>
  );
};
